
export default {
  data() {
    return {
      pageData: null,
      categories: [],
      selectedCategory: null,
      dropdownOpen: false,
      categoryTitle: "",
    };
  },
  watch: {
    selectedCategory() {
      this.changeCategory();
    },
  },
  mounted() {
    this.getPageData();
  },
  methods: {
    changeCategory() {
      this.$router.push({
        query: { category: this.selectedCategory },
      });
      for (let i = 0; i < this.categories.length; i++) {
        if (this.categories[i].slug === this.selectedCategory) {
          this.$root.$emit("categoryName", this.categories[i].title);
          this.categoryTitle = this.categories[i].title;
        }
      }
    },
    getPageData() {
      this.pageData = this.$parent.$parent.pageData;
      this.getCategories();
    },
    async getCategories() {
      if (
        this.pageData &&
        this.pageData.components &&
        this.pageData.components.length &&
        this.pageData.components[0].linkMeta.categories
      )
        this.categories = await this.$getCategoriesInGroup(
          this.pageData.components[0].linkMeta.categories.replace(
            /(<([^>]+)>)/gi,
            ""
          )
        );
      if (this.$route && this.$route.query && this.$route.query.category) {
        this.selectedCategory = this.$route.query.category;
        for (let i = 0; i < this.categories.length; i++) {
          if (this.categories[i].slug === this.selectedCategory) {
            this.$root.$emit("categoryName", this.categories[i].title);
          }
        }
      }
    },
    toggleDropdown() {
      this.dropdownOpen = !this.dropdownOpen;
    },
  },
};
